import Vue from 'vue'
import LandingCart from './components/LandingCart.vue'
import vueCustomElement from 'vue-custom-element'

Vue.use(vueCustomElement);

Vue.customElement('landing-cart', LandingCart, { shadow: false })
